import { queryClient, useMutation } from '../../../ReactQuery';
import { remove } from '../../../redux/api';
import type { TeamWithAssociations } from '../../../../shared/types/routes/teams';

import { getTeamsQueryKey } from './useTeams';

//  Note: I have no idea why this is what the API returns.
//  See routes/teams.ts for the API implementation.
type DeleteTeamResponse = {
  teamId: number;
  releaseGroups: number[];
};

//  Function to delete a team
function deleteTeam(teamId: number) {
  return remove<void, DeleteTeamResponse>(`/api/teams/${teamId}`);
}

/**
 * useDeleteTeam is a hook that deletes a team and removes it from the cache.
 */
export default function useDeleteTeam(teamId: number) {
  return useMutation({
    mutationFn: () => deleteTeam(teamId),
    onSuccess: () => {
      // First we add the new team to the cache, so that it appears immediately.
      queryClient.setQueryData(getTeamsQueryKey, (oldTeams: TeamWithAssociations[] | undefined) => {
        return oldTeams?.filter((team) => team.id !== teamId) ?? [];
      });
    },
  });
}
